import userInfo from 'hub-http/userInfo';
import Raven from 'raven-js';
import { gate } from 'hub-http/gates';
import { useEffect, useState } from 'react';
const useUserInfo = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [authData, setAuthData] = useState(null);
  useEffect(() => {
    setIsLoading(true);
    userInfo().then(data => {
      setAuthData(data);
      setIsLoading(false);
    }).catch(error => {
      Raven.captureException(error, {
        extra: {
          description: 'Failed to fetch user info"'
        }
      });
      setAuthData(null);
      setIsLoading(false);
    });
  }, []);
  return {
    isLoading,
    authData
  };
};
export const useIsUngatedForBETranslations = () => {
  var _authData$gates$inclu, _authData$gates;
  const {
    isLoading,
    authData
  } = useUserInfo();
  const value = (_authData$gates$inclu = authData === null || authData === void 0 || (_authData$gates = authData.gates) === null || _authData$gates === void 0 ? void 0 : _authData$gates.includes(gate('Developers::BEAppPermissionTranslations'))) !== null && _authData$gates$inclu !== void 0 ? _authData$gates$inclu : false;
  return [isLoading, value];
};